var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragvertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3H11.5V5H9.5V3ZM13.5 3H15.5V5H13.5V3ZM9.5 7H11.5V9H9.5V7ZM13.5 7H15.5V9H13.5V7ZM9.5 11H11.5V13H9.5V11ZM13.5 11H15.5V13H13.5V11ZM9.5 15H11.5V17H9.5V15ZM13.5 15H15.5V17H13.5V15ZM9.5 19H11.5V21H9.5V19ZM13.5 19H15.5V21H13.5V19Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragvertical);
export default __webpack_public_path__ + "static/media/dragvertical.b2bf944e1d1097c2fb49c419d8fa80f1.svg";
export { ForwardRef as ReactComponent };